import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=48fc5a9e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=48fc5a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc5a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fc5a9e')) {
      api.createRecord('48fc5a9e', component.options)
    } else {
      api.reload('48fc5a9e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=48fc5a9e&scoped=true&", function () {
      api.rerender('48fc5a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27UopW193o4ot/JS/teamMember.vue"
export default component.exports